import useFichaComercial from './useFichaComercial'
import ComercialFichaOrganizacion from './ComercialFichaOrganizacion'
import ComercialFichaContacto from './ComercialFichaContacto'

// Mounted once on each Comercial list page: draws the card open in the address
// (useFichaComercial: ?org=<id> or ?contacto=<id>, or a new one's form), if any.
// Both cards also hold their forms (create and edit in the same panel).
//   onCambio(): an organization or a contact was saved, linked, archived, restored
//   or deleted (the page reloads its list)
export default function ComercialFichas({ onCambio }) {
  const { ficha, abrir, reemplazar, atras, cerrar } = useFichaComercial()
  if (!ficha) return null
  const props = { id: ficha.id, abrir, reemplazar, atras, cerrar, onCambio }
  return ficha.tipo === 'org'
    ? <ComercialFichaOrganizacion key={`org-${ficha.id}-${ficha.superior || ''}`} {...props} superior={ficha.superior} />
    : <ComercialFichaContacto key={`contacto-${ficha.id}-${ficha.desde || ''}`} {...props} desde={ficha.desde} />
}
